module.exports = __webpack_public_path__ + "static/img/ext7.6f94dae5.jpg";